module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "mt-4 pb-0 text-center green lighten-2",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-img', {
    attrs: {
      "src": '/static/calendarEventImages/img_birthday_1x.jpg'
    }
  }, [_c('v-card-title', [_vm._v("Alles Gute zum Geburtstag!")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-12ff17a6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/card/home/cardHomeBirthday.vue
// module id = 736
// module chunks = 15